import { UserModel } from '../../../core/models/user/user.model';
import { ProjectTaskModel } from '../../../core/models/project/project-task.model';
import { ExpenditureRateEntry } from '../../../core/models/project/project-expenditure-entry.model';
import { TimeUnits } from '../../../shared/data-types/unit-types';

export type ProjectMemberPropertiesWrapper = {
  member: UserModel;
  deductCostsFromBudget: boolean;
};

export type ProjectMemberGridRow = ProjectMemberPropertiesWrapper & {
  member: UserModel;
  budgetSeconds: number;
  expenditureRateHistory: ExpenditureRateEntry[];
};

export type ProjectTaskGridRow = {
  task: ProjectTaskModel;
  budgetSeconds: number;
  budgetMonetary: number;
  expenditureRateHistory: ExpenditureRateEntry[];
};

export enum ProjectStatusFilter {
  All,
  Active,
  Archived,
}

export type TaskDetailGridRow = {
  task: ProjectTaskModel;
  spentSeconds: number;
  spentFees: number;
  budget: number;
};

export type MemberDetailGridRow = {
  member: UserModel;
  spentSeconds: number;
  spentFees: number;
  budget: number;
  costs: number;
};

export type ApplicableChartTimeUnits = TimeUnits.Month | TimeUnits.Year;
